define('drops/timeInput/timeInput',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    'lq/util',
    'lq/dayTime',
    'jquery.timepicker',
    'lq/required'
], function ($, _, Drop, Style, util, dayTime, timepicker, Required) {
    'use strict';

    TimeInput.NATURAL_NUMBER = 'naturalnumber';
    TimeInput.DATE_TIME = 'datetime';

    var defaults = {
        data: {
            storageType: TimeInput.NATURAL_NUMBER,
            withDropDown: false,
            step: 30,
            required: {
                initialVisibility: true,
                isRequired: false,
                valueSource: 'hardcoded'
            },
            changedDelay: 500,
        }
    };

    var placeholder = '--:--';

    function TimeInput(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing) || {};

        this.data.eventing.focusLost = this.data.eventing.focusLost || this.data.eventing.focuslost; // old broken reference
        delete this.data.eventing.focuslost;

        var self = this;
        this.$input = $('<input />')
            .attr('name', this.data.name)
            .attr('tabindex', this.data.tabIndex)
            .css({
                width: '100%',
                height: '100%'
            })
            .val(placeholder)
            .on('blur', function() {
                self.displayValue(self.getValue());
            })
            .on('focus', function() {
                if (self.$input.val() === placeholder)
                    self.$input.val('');
            })
            .addClass('boxToBorderSize')
            .appendTo(this.$element);

        if (this.data.eventing.focusLost && this.data.eventing.focusLost.enabled === true) {
            this.$input.on('blur', function () {
                self.triggerEvent(self.data.eventing.focusLost.raisedEventName, self.getValue());
            });
        }

        this.$element
            .addClass('boxToBorderSize')
            .css({ whiteSpace: 'pre-wrap' });

        Style.renderStyles(this, null, this.$input);

        this.$input.on('keyup', function () {
            self.updateRequiredIndicator();
        });

        if (this.data.readOnly)
            this.$input.prop('readonly', true);

        var changedEvent = this.getEventDataFor('changed');
        if (changedEvent.enabled) {
            this.subscribeEventHandler(this.$input, 'keydown', function () {
                if (!_.has(self, 'lastChangedEventValue'))
                    self.lastChangedEventValue = self.getValue();
            });
            this.subscribeEventHandler(this.$input, 'keypress input', _.debounce(function () {
                self.triggerChangeEvent();
            }, this.data.changedDelay));
        }
    };

    Drop.extend(TimeInput, Drop);

    TimeInput.typeName = 'TimeInput';

    TimeInput.prototype.triggerChangeEvent = function () {
        if (this.lastChangedEventValue !== this.getValue()) {
            this.lastChangedEventValue = this.getValue();
            this.triggerEventIfEnabled('changed');
        }
    };

    TimeInput.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.piping.required.apply(this);
        Required.prototype.addRemoveRequiredIndicator(this);
        this.applyPosition();
    };

    TimeInput.prototype.postRender = function () {
        if (this.data.withDropDown) {
            var self = this;
            this.$input
                .timepicker({
                    timeFormat: 'H:i',
                    scrollDefault: 'now',
                    step: this.data.step
                })
                .on('changeTime', function () {
                    self.triggerEventIfEnabled('selected', self.getValue());
                    self.$input.timepicker('hide');
                })
                .on('change', function () {
                    var value = self.getValue();

                    if (this.lastChangedEventValue === value)
                        return;

                    self.triggerChangeEvent();

                    self.$input.timepicker('hide');
                });
        }
    };

    TimeInput.prototype.focus = function () {
        this.$input.trigger('focus');
    };

    TimeInput.prototype.getValue = function () {
        var value = this.$input.val();
        if (this.data.storageType === TimeInput.NATURAL_NUMBER) {
            return dayTime.toTicks(value);
        } else {
            return dayTime.toDate(this.piping, value);
        }
    };

    TimeInput.prototype.clearValue = function () {
        this.$input.val(null);
        this.updateRequiredIndicator();
        this.lastChangedEventValue = '';
    };

    TimeInput.prototype.setValue = function (update) {
        this.displayValue(update.value);
        this.lastChangedEventValue = update.value;
    };

    TimeInput.prototype.displayValue = function (val) {
        var stringValue;
        if (this.data.storageType === TimeInput.NATURAL_NUMBER) {
            stringValue = dayTime.fromTicks(val);
        } else {
            stringValue = dayTime.fromDate(this.piping, val);
        }

        this.$input.val(stringValue);
        this.updateRequiredIndicator();
    };

    return TimeInput;
});
